export default __webpack_public_path__ + "static/media/logo-atlassian.5d5ef092.svg";